export default function TransformTetrisSeo() {
  return (
    <>
      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "0 0 12px" }}>
        Transformations as named moves
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Geometric transformations — rotation, reflection, translation, glide
        reflection — are usually taught as separate chapters with separate
        formulas, and students never quite see them as a unified vocabulary.
        Transform Tetris fixes that. Every level shows you a starting shape
        and a target position, and your only tools are the four named
        transformations applied in sequence. You learn which transformation
        is which by *using* them, and the geometry becomes a language with
        a small, named verb set.
      </p>

      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "24px 0 12px" }}>
        Why this is the right way to learn rigid motions
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Rigid motions are the foundation of Euclidean geometry — the set of
        all transformations that preserve distance and angle. Every result
        in classical geometry about "congruence" is built on these four
        moves. Students who learn them as recipes never internalize this.
        Students who learn them as a *toolkit* — pick the right move for
        the situation — develop the geometric intuition that makes proofs
        feel like puzzle-solving instead of formula-memorization.
      </p>

      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "24px 0 12px" }}>
        The level structure
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Early levels need a single transformation — recognize that the
        shape has been rotated 90° clockwise, apply the inverse, win. Middle
        levels need two transformations in sequence and force you to think
        about *order* (rotate-then-reflect is not the same as reflect-then-
        rotate). Late levels combine three or four moves and have only one
        valid composition, which trains the precision of identifying
        exactly what each transformation does. Every level is verified
        solvable by exactly one candidate sequence.
      </p>
    </>
  );
}
